import { Link } from '@inertiajs/react'
import AppLayout from '../../components/AppLayout'

const STATE_META = {
  running: { label: '実行中', bg: '#fef3c7', text: '#92400e' },
  done:    { label: '完了',   bg: '#dcfce7', text: '#166534' },
  error:   { label: 'エラー', bg: '#fee2e2', text: '#991b1b' },
}

function formatDuration(sec) {
  if (sec == null) return '—'
  if (sec < 60) return `${sec}秒`
  const m = Math.floor(sec / 60)
  const s = sec % 60
  return `${m}分${s}秒`
}

export default function RecomputeRunsIndex({ runs }) {
  return (
    <AppLayout title="全件再評価の実行履歴">
      <div style={{ marginBottom: '12px' }}>
        <Link href="/evaluation_criteria" style={{ color: '#4338ca', textDecoration: 'none', fontSize: '13px' }}>
          ← 評価指標マスタ
        </Link>
      </div>

      {runs.length === 0 ? (
        <div style={{ background: 'white', borderRadius: '10px', padding: '32px', textAlign: 'center', color: '#94a3b8', fontSize: '13px', boxShadow: '0 1px 3px rgba(0,0,0,0.07)' }}>
          実行履歴はありません
        </div>
      ) : (
        <div style={{ background: 'white', borderRadius: '10px', boxShadow: '0 1px 3px rgba(0,0,0,0.07)', overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
            <thead>
              <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                <th style={th}>開始日時</th>
                <th style={th}>状態</th>
                <th style={{ ...th, textAlign: 'right' }}>所要時間</th>
                <th style={{ ...th, textAlign: 'right' }}>件数</th>
                <th style={{ ...th, textAlign: 'right' }}>完了</th>
                <th style={{ ...th, textAlign: 'right' }}>エラー</th>
                <th style={th}>実行者</th>
                <th style={th}></th>
              </tr>
            </thead>
            <tbody>
              {runs.map((r, i) => {
                const sm = STATE_META[r.state] || { label: r.state, bg: '#e4e4e4', text: '#555' }
                return (
                  <tr key={r.id} style={{ borderBottom: '1px solid #f1f5f9', background: i % 2 === 0 ? 'white' : '#fafafa' }}>
                    <td style={td}>{new Date(r.started_at).toLocaleString('ja-JP')}</td>
                    <td style={td}>
                      <span style={{ padding: '2px 7px', borderRadius: '4px', background: sm.bg, color: sm.text, fontWeight: 600, fontSize: '11px' }}>
                        {sm.label}
                      </span>
                    </td>
                    <td style={{ ...td, textAlign: 'right', fontFamily: "'JetBrains Mono', monospace" }}>{formatDuration(r.duration_sec)}</td>
                    <td style={{ ...td, textAlign: 'right', fontFamily: "'JetBrains Mono', monospace" }}>{r.total_count}</td>
                    <td style={{ ...td, textAlign: 'right', fontFamily: "'JetBrains Mono', monospace" }}>{r.done_count}</td>
                    <td style={{ ...td, textAlign: 'right', fontFamily: "'JetBrains Mono', monospace", color: r.error_count > 0 ? '#991b1b' : '#94a3b8' }}>{r.error_count}</td>
                    <td style={{ ...td, color: '#64748b' }}>{r.triggered_by || '—'}</td>
                    <td style={td}>
                      <Link href={`/recompute_runs/${r.id}`} style={{ fontSize: '11px', color: '#4338ca', textDecoration: 'none', border: '1px solid #4338ca', borderRadius: '3px', padding: '2px 8px' }}>詳細</Link>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      )}
    </AppLayout>
  )
}

const th = { padding: '8px 12px', textAlign: 'left', fontSize: '11px', fontWeight: 600, color: '#64748b', whiteSpace: 'nowrap' }
const td = { padding: '9px 12px', verticalAlign: 'middle' }
